import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { border } from './primitive/border';
import {
  orange,
  surface,
  gray,
  highlight,
  focus,
  formField,
  text,
  anchor,
  overlay,
  list,
  mask,
} from './semantic';
import { primary } from './semantic/primary';
import {
  badge,
  button,
  datatable,
  datepicker,
  multiselect,
  tabs,
  card,
  autocomplete,
  accordion,
  tree,
  treeselect,
  tag,
} from './components';

const tourfoldWebappTheme = definePreset(Aura, {
  primitive: {
    ...border,
  },
  semantic: {
    ...primary,
    accent: {
      ...orange,
    },
    colorScheme: {
      light: {
        ...surface,
        ...gray,
        ...highlight,
        ...focus,
        ...formField,
        ...text,
        ...anchor,
        ...overlay,
        ...list,
        ...mask,
      },
    },
  },
  components: {
    ...button,
    ...multiselect,
    ...tabs,
    ...datatable,
    ...datepicker,
    ...badge,
    ...card,
    ...autocomplete,
    ...accordion,
    ...tree,
    ...treeselect,
    ...tag,
  },
});

export default tourfoldWebappTheme;
